<div class="pricing-template-delete-warning"> callate puto
    <div class="mt-1 mb-2 text-center">
        You are {{ data.action }} your current default margin template. Please select
        another margin template below. Your default template will be used for
        newly added customers or if you delete a margin template with customers
        assigned to it.
    </div>

    <div class="text-center">
        <mat-form-field>
            <mat-select
                [(ngModel)]="selectedTemplate"
                placeholder="Margin Template"
                required
            >
                <mat-option
                    *ngFor="let pricingTemplate of data.data"
                    [value]="pricingTemplate.oid"
                >
                    {{ pricingTemplate.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="text-center">
        <button (click)="onSelect()" color="green" mat-stroked-button>
            Change Default Template
        </button>
        <button (click)="onCancelClick()" mat-stroked-button>
            Cancel
        </button>
    </div>
</div>
